import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { SubgroupModel } from 'src/app/models/archive/subgroup.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { SubgroupImportModel } from 'src/app/models/imports/subgroup-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubgroupService {

  constructor(private _httpClient: HttpClient) { }

  createSubgroup(subgroupContractModel: SubgroupModel): Observable<SubgroupModel> {
    return this._httpClient.post<SubgroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.CreateSubgroup}`,
      subgroupContractModel);
  }

  deleteSubgroup(subgroupId: number): Observable<SubgroupModel> {
    return this._httpClient.delete<SubgroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.DeleteSubgroup}/${subgroupId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllSubgroupsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.GetAllSubgroupsForSelectAsync}`,);
  }

  getAllSubgroupsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.GetAllSubgroupsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getByGroupId(groupId: number): Observable<Array<SubgroupModel>> {
    return this._httpClient.get<Array<SubgroupModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.GetByGroupId}/${groupId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.GetColumnsForGeneralConsultationAsync}`);
  }

  getGroupByCode(groupId: number, code: string): Observable<SubgroupModel> {
    const itemFilterResponse = new ItemFilterModel("code", groupId, null, "");
    itemFilterResponse.wildcard = code;
    return this._httpClient.post<SubgroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.GetSubgroupByCode}`, itemFilterResponse);
  }

  getSubgroupById(subgroupId: number): Observable<SubgroupModel> {
    return this._httpClient.get<SubgroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.GetSubgroupById}/${subgroupId}`);
  }

  importSubgroups(subgroupImports: Array<SubgroupImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.ImportSubgroups}`, subgroupImports);
  }

  updateSubgroup(subgroupContractModel: SubgroupModel): Observable<SubgroupModel> {
    return this._httpClient.put<SubgroupModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.subgroup.UpdateSubgroup}`,
      subgroupContractModel);
  }
}
